<template>
  <section class="alarmBox">
    <qxCard title="提示" id="tips">
      <div class="tipBox">
        <p>基础报警数据查询：报警管理-->报警统计-->报警统计报表/报警处理报表</p>
        <p>主动安全报警数据：主动安全-->主动安全报警</p>
        <p>人脸对比数据查询：主动安全-->人脸对比记录</p>
        <p>请使用该账号登录：
          <span class="loginText">
            <span v-if="show">
              <span  @copy="copy">用户名：{{this.thirdPartyAccount}}</span>
              <span  @copy="copy"> 密码：{{this.thirdPartyPassword}}</span>
            </span>
            <span v-if="flag">请联系平台客服创建账号后使用！</span>
          </span>
        </p>
      </div>
    </qxCard>
    <div class="butBox">
      <img class="bgImg" src="~images/service/securityAlarm.png" />
      <el-button class='jumpBut' @click="jump">
        <img class="tmplImg" src="~images/service/jumpButton.png" />
      </el-button>
    </div>
  </section>
</template>

<script>
import {thirdPartyAccountNumber} from 'api/operate';
export default {
  name: 'alarmFace',
  data () {
    return {
      thirdPartyAccount: '',
      thirdPartyPassword: '',
      flag: false,
      show: true,
    };
  },
  methods: {
    async getData () {
      const res = await thirdPartyAccountNumber({
        type: 1,
      });
      this.thirdPartyAccount = res.thirdPartyAccount;
      this.thirdPartyPassword = res.thirdPartyPassword;
      if (!this.thirdPartyAccount && !this.thirdPartyPassword) {
        this.flag = true;
        this.show = false;
      }
    },
    jump () {
      window.open('http://152.136.209.77:6006/Mvsp/Index/Default.jsp?pswStrength=true');
    },
    copy (event) {
      // 获取剪切板内容
      let content = window.getSelection().toString();
      // 判断当前浏览器是否支持获取剪切板内容
      if (event.clipboardData || event.originalData) {
        // 获取剪切板对象
        let clipbordData = (event.clipboardData || window.clipboardData);
        // 重新设置剪切板内容
        clipbordData.setData('text/plain', content.trim());
        event.preventDefault();
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.alarmBox{
  .tipBox{
    margin-left:12px;
    height: 122px;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Normal;
    font-weight: Normal;
    text-align: left;
    color: #333333;
    line-height: 36px;

    .loginText{
      width: 280px;
      height: 29px;
      font-size: 20px;
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
      font-weight: 700;
      text-align: left;
      color: #fe8908;
      line-height: 37px;
      background: #fff5e3;
      border: 1px solid #f2ddbe;
      border-radius: 7px;
      padding: 5px;
    }
  }
  .butBox{


    .bgImg {
      position: relative;
      height: 100%;
      width:100%;
    }
    .jumpBut{
      position: absolute;
      top:600px;
      right:287px;
      background: #0C57DB;
      border:0;

      .tmplImg{
        width:100%;
        height:100%;
      }
    }
  }

}


</style>
